<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'time-tracking.confirmDeleteTimesheetEntry' | translate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.timesheetsIndexPage.payrollLockedModalHeader"
    primaryButtonLabel="time-tracking.timesheetsIndexPage.payrollLockedModalConfirm"
    #payrollLockedModal
>
    <p [innerHTML]="'time-tracking.timesheetsIndexPage.payrollLockedModalDescription' | translate"></p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="time-tracking.timesheetsIndexPage.approveAll"
    secondaryButtonLabel="cancel"
    #confirmApproveAll
>
    <div
        [innerHTML]="
            'time-tracking.timesheetsIndexPage.confirmApproveAll' | translate: { count: pendingTimesheetEntryCount }
        "
    ></div>
</ui-confirmation-dialog>

<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header [title]="'time-tracking.timesheetsIndexPage.title'" [menuService]="menuService">
        <ui-button class="buttons" type="primary" [routerLink]="['create']"
            >{{ 'time-tracking.timesheetsIndexPage.enterHoursForEmployees' | translate }}
        </ui-button>
    </app-header>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            [isResponsive]="true"
            [noPadding]="true"
            [embedded]="true"
            [showOffset]="true"
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            (action)="onAction($event)"
        >
            <app-empty-state
                label="{{
                    (table.isEmpty
                        ? 'time-tracking.timesheetsIndexPage.noTimesheets'
                        : 'time-tracking.timesheetsIndexPage.noTimesheetsInFilter'
                    ) | translate
                }}"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button
                    class="buttons"
                    type="primary"
                    [disabled]="pendingTimesheetEntryCount === 0"
                    (click)="onApproveAll()"
                >
                    {{ 'time-tracking.timesheetsIndexPage.approveAll' | translate }}
                </ui-button>
            </div>
        </app-table>
    </ui-card>
</div>
